<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="primary white--text title">
                    Graphical View
                </v-card-title>
                <v-card-text>
                    <graphical-sensor-component></graphical-sensor-component>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  import GraphicalSensorComponent from '../components/graphicalsensorview/GraphicalSensorComponent'
  export default {
    name: 'GraphicalSensorView',
    components: { GraphicalSensorComponent },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>

</style>
